export const work_data=[{
    name:'软件工程师',
    ask:['天津','1-3年','本科'],
    welfare:['绩效奖金','每年多次调薪','五险一金','周末双休'],
    state:'最新',
    details:[['参与项目相关部分需求分析，负责客户端具体编码工作；','参与与其他团队的沟通协调，按质按时完成领导分配的任务；','有责任感、工作态度严谨，能够承担高强度、高压力的工作，有较强的分析能力及学习能力；','思路清晰，具备良好的沟通能力和理解能力；'],['计算机科学与技术或软件工程专业本科学历，985、211院校优先；','相关专业开发经验3年以内或者应届毕业生；','熟练掌握C#或JAVA至少一种开发语言；','熟练掌握Html、JavaScript、H5、CSS3，至少熟练掌握vue2、vue3一种；','熟悉SQL Server或MySQL等关系型数据库设计，能够熟练的编写常用的sql，简单优化sql; ','具有一定的系统分析，算法设计能力；','有一定的技术文档编写能力和良好的编程书写规范;','有移动端开发、ARCGIS、机器学习、供排水相关项目经验者优先.']]
},{
    name:'给排水工程师',
    ask:['天津','1-3年','本科'],
    welfare:['每年多次调薪','五险一金','绩效奖金'],
    state:'最新',
    details:[['能进行智慧水务的交流推广，根据水司需求进行技术方案的编制；','根据项目需求，对第三方项目合作进行项目管理；','根据工作需要编制其他解决方案。'],['给排水/环境工程相关专业本科学历，985、211院校优先；','相关专业经验3年以内或者应届毕业生；','对城镇供水业务有一定了解；','熟悉自来水公司业务优先；','有智慧水务项目经历优先；','团队协作能力及沟通能力强;','能适应出差']]
}
// ,{
//     name:'java软件工程师',
//     ask:['天津','1-3年','本科'],
//     welfare:['绩效奖金','每年多次调薪','五险一金','周末双休'],
//     state:'招聘中',
//     details:[['参与项目相关部分需求分析，负责客户端具体编码工作；','参与与其他团队的沟通协调，按质按时完成领导分配的任务；','有责任感、工作态度严谨，能够承担高强度、高压力的工作，有较强的分析能力及学习能力；','思路清晰，具备良好的沟通能力和理解能力；'],['精通java语言，具有至少3年以上的java开发经验;','熟悉Oracle/MySQL等关系型数据库，能够熟练的编写常用的sql，简单优化sql;','熟悉Spring、Hibernate等主流框架;','熟练掌握常用面向对象设计模式如：Factory、Singleton、Mvc、Proxy等；','有良好的算法设计与逻辑分析能力，具有多线程并发处理、Socket通信开发经验；','具有良好的人际交往、语言表达和沟通能力；有ARCGIS、机器学习、给排水相关项目经验者优先。']]
// }
]